import { Inject, Injectable, Injector } from '@angular/core';

import { Utilities_FlowService } from './Utilities.flow.index';
import { FootprintApiManager_FlowService } from './FootprintApiManager.flow.index';
import { FootprintEdi_FlowService } from './FootprintEdi.flow.index';

import { app_MHI_edi_datex_order_info_to_x12_4010_945Service } from './app.flow.index';
import { app_MHI_edi_x12_4010_940_to_datex_order_infoService } from './app.flow.index';
import { app_custom_edi_process_entity_import_contentService } from './app.flow.index';
import { app_custom_edi_submit_entity_import_xml_requestService } from './app.flow.index';
import { app_edi_export_completed_shipmentsService } from './app.flow.index';
import { app_edi_export_inventory_adjustmentsService } from './app.flow.index';
import { app_edi_export_inventory_snapshotService } from './app.flow.index';
import { app_edi_set_wavelength_connector_transmissionService } from './app.flow.index';
import { app_edi_sftp_pull_and_submitService } from './app.flow.index';
import { app_edi_sftp_pushService } from './app.flow.index';
import { app_edi_submit_entity_import_xml_requestService } from './app.flow.index';
import { app_edi_x12_940_mapService } from './app.flow.index';
import { app_edi_x12_945_mapService } from './app.flow.index';
import { app_edi_xml_submit_omicronService } from './app.flow.index';
import { app_sftp_pullService } from './app.flow.index';
import { app_sftp_pull_and_submitService } from './app.flow.index';
import { app_sftp_pushService } from './app.flow.index';

import { $frontendTypes } from './app.frontend.types'

@Injectable({ providedIn: 'root' })
export class app_FlowService {

  constructor(
    private injector: Injector
  ) {
    this.Utilities = this.injector.get(Utilities_FlowService);
    this.FootprintApiManager = this.injector.get(FootprintApiManager_FlowService);
    this.FootprintEdi = this.injector.get(FootprintEdi_FlowService);
  }

    public Utilities: Utilities_FlowService;
    public FootprintApiManager: FootprintApiManager_FlowService;
    public FootprintEdi: FootprintEdi_FlowService;
  public app: app_FlowService = this;

  // injecting lazily in order to avoid circular dependencies
 
  private _MHI_edi_datex_order_info_to_x12_4010_945: app_MHI_edi_datex_order_info_to_x12_4010_945Service;
  public async MHI_edi_datex_order_info_to_x12_4010_945($inParams: { XML?: string, Data?: $frontendTypes.FootprintEdi.DatexMapInfo }): Promise< { X12?: $frontendTypes.FootprintEdi.X12_00401_945[] }> {
    if(!this._MHI_edi_datex_order_info_to_x12_4010_945) { 
      this._MHI_edi_datex_order_info_to_x12_4010_945 = this.injector.get(app_MHI_edi_datex_order_info_to_x12_4010_945Service);
    }
    return this._MHI_edi_datex_order_info_to_x12_4010_945.run($inParams);
  }
   
   

   
 
  private _MHI_edi_x12_4010_940_to_datex_order_info: app_MHI_edi_x12_4010_940_to_datex_order_infoService;
  public async MHI_edi_x12_4010_940_to_datex_order_info($inParams: { XML?: string, Data?: $frontendTypes.FootprintEdi.DatexMapInfo }): Promise< { DatexOrderInfo?: $frontendTypes.FootprintEdi.DatexOrderInfo }> {
    if(!this._MHI_edi_x12_4010_940_to_datex_order_info) { 
      this._MHI_edi_x12_4010_940_to_datex_order_info = this.injector.get(app_MHI_edi_x12_4010_940_to_datex_order_infoService);
    }
    return this._MHI_edi_x12_4010_940_to_datex_order_info.run($inParams);
  }
   
   

   
 
  private _custom_edi_process_entity_import_content: app_custom_edi_process_entity_import_contentService;
  public async custom_edi_process_entity_import_content($inParams: { integration_id?: string, entity_import_content?: string, transaction_id?: string }): Promise< { results?: any[], entity_import_content?: string, validation_results?: { level?: number, message?: string }[], do_not_submit?: boolean }> {
    if(!this._custom_edi_process_entity_import_content) { 
      this._custom_edi_process_entity_import_content = this.injector.get(app_custom_edi_process_entity_import_contentService);
    }
    return this._custom_edi_process_entity_import_content.run($inParams);
  }
   
   

   
 
  private _custom_edi_submit_entity_import_xml_request: app_custom_edi_submit_entity_import_xml_requestService;
  public async custom_edi_submit_entity_import_xml_request($inParams: { integration_id?: string, entity_import_content?: string, transaction_id?: string }): Promise< { request_id?: string, validation_result?: { level?: number, message?: string }[] }> {
    if(!this._custom_edi_submit_entity_import_xml_request) { 
      this._custom_edi_submit_entity_import_xml_request = this.injector.get(app_custom_edi_submit_entity_import_xml_requestService);
    }
    return this._custom_edi_submit_entity_import_xml_request.run($inParams);
  }
   
   

   
 
  private _edi_export_completed_shipments: app_edi_export_completed_shipmentsService;
  public async edi_export_completed_shipments($inParams: { project_lookups?: string[], project_ids?: number[], days?: number, shipment_type?: number, transaction_type?: string, has_order_transmissions?: boolean, in_transmission_type?: string, out_transmission_type?: string, integration_id?: string }): Promise<void> {
    if(!this._edi_export_completed_shipments) { 
      this._edi_export_completed_shipments = this.injector.get(app_edi_export_completed_shipmentsService);
    }
    return this._edi_export_completed_shipments.run($inParams);
  }
   
   

   
 
  private _edi_export_inventory_adjustments: app_edi_export_inventory_adjustmentsService;
  public async edi_export_inventory_adjustments($inParams: { owner_lookup?: string, project_lookup: string, integration_id: string, transaction_type: string, transaction_id?: string, render_options?: { lots?: boolean, license_plates?: boolean, serial_numbers?: boolean }, days?: number, operation_codes?: string[] }): Promise< { messages?: any[] }> {
    if(!this._edi_export_inventory_adjustments) { 
      this._edi_export_inventory_adjustments = this.injector.get(app_edi_export_inventory_adjustmentsService);
    }
    return this._edi_export_inventory_adjustments.run($inParams);
  }
   
   

   
 
  private _edi_export_inventory_snapshot: app_edi_export_inventory_snapshotService;
  public async edi_export_inventory_snapshot($inParams: { owner_lookup?: string, project_lookup: string, integration_id: string, transaction_type: string, transaction_id?: string, render_options?: { lots?: boolean, license_plates?: boolean, serial_numbers?: boolean, only_inventory?: boolean, only_physical?: boolean, date_format?: string } }): Promise< { messages?: any[] }> {
    if(!this._edi_export_inventory_snapshot) { 
      this._edi_export_inventory_snapshot = this.injector.get(app_edi_export_inventory_snapshotService);
    }
    return this._edi_export_inventory_snapshot.run($inParams);
  }
   
   

   
 
  private _edi_set_wavelength_connector_transmission: app_edi_set_wavelength_connector_transmissionService;
  public async edi_set_wavelength_connector_transmission($inParams: { shipment_id?: number, integration_id: string, transaction_id: string, transaction_type?: string, file_content: string }): Promise<void> {
    if(!this._edi_set_wavelength_connector_transmission) { 
      this._edi_set_wavelength_connector_transmission = this.injector.get(app_edi_set_wavelength_connector_transmissionService);
    }
    return this._edi_set_wavelength_connector_transmission.run($inParams);
  }
   
   

   
 
  private _edi_sftp_pull_and_submit: app_edi_sftp_pull_and_submitService;
  public async edi_sftp_pull_and_submit($inParams: { integration_id: string, sftp_connection: string, sftp_path: string, sftp_extension?: string }): Promise<void> {
    if(!this._edi_sftp_pull_and_submit) { 
      this._edi_sftp_pull_and_submit = this.injector.get(app_edi_sftp_pull_and_submitService);
    }
    return this._edi_sftp_pull_and_submit.run($inParams);
  }
   
   

   
 
  private _edi_sftp_push: app_edi_sftp_pushService;
  public async edi_sftp_push($inParams: { integration_id: string, file_content: string, transaction_type?: string }): Promise<void> {
    if(!this._edi_sftp_push) { 
      this._edi_sftp_push = this.injector.get(app_edi_sftp_pushService);
    }
    return this._edi_sftp_push.run($inParams);
  }
   
   

   
 
  private _edi_submit_entity_import_xml_request: app_edi_submit_entity_import_xml_requestService;
  public async edi_submit_entity_import_xml_request($inParams: { integration_id?: string, entity_import_content?: string }): Promise< { request_id?: string }> {
    if(!this._edi_submit_entity_import_xml_request) { 
      this._edi_submit_entity_import_xml_request = this.injector.get(app_edi_submit_entity_import_xml_requestService);
    }
    return this._edi_submit_entity_import_xml_request.run($inParams);
  }
   
   

   
 
  private _edi_x12_940_map: app_edi_x12_940_mapService;
  public async edi_x12_940_map($inParams: { integration_id?: string, transaction_id?: string, correlation_id?: string, transaction_type?: string, x12_xml?: string }): Promise< { datex_order_info?: string }> {
    if(!this._edi_x12_940_map) { 
      this._edi_x12_940_map = this.injector.get(app_edi_x12_940_mapService);
    }
    return this._edi_x12_940_map.run($inParams);
  }
   
   

   
 
  private _edi_x12_945_map: app_edi_x12_945_mapService;
  public async edi_x12_945_map($inParams: { integration_id?: string, transaction_id?: string, correlation_id?: string, transaction_type?: string, datex_order_info?: string }): Promise< { x12_xml?: string }> {
    if(!this._edi_x12_945_map) { 
      this._edi_x12_945_map = this.injector.get(app_edi_x12_945_mapService);
    }
    return this._edi_x12_945_map.run($inParams);
  }
   
   

   
 
  private _edi_xml_submit_omicron: app_edi_xml_submit_omicronService;
  public async edi_xml_submit_omicron($inParams: { XMLContent?: string, CorrelationId?: string, TransactionId?: string, IntegrationId?: string }): Promise<void> {
    if(!this._edi_xml_submit_omicron) { 
      this._edi_xml_submit_omicron = this.injector.get(app_edi_xml_submit_omicronService);
    }
    return this._edi_xml_submit_omicron.run($inParams);
  }
   
   

   
 
  private _sftp_pull: app_sftp_pullService;
  public async sftp_pull($inParams: { connection: string, source_path: string, archive_path?: string, error_path?: string, file_extension?: string, file_name?: string, sort_asc?: boolean, transaction_id?: string }): Promise< { messages?: any[], success?: boolean, files?: { file_name?: string, file_blob?: any }[] }> {
    if(!this._sftp_pull) { 
      this._sftp_pull = this.injector.get(app_sftp_pullService);
    }
    return this._sftp_pull.run($inParams);
  }
   
   

   
 
  private _sftp_pull_and_submit: app_sftp_pull_and_submitService;
  public async sftp_pull_and_submit($inParams: { integration_id: string, sftp_connection: string, sftp_path: string, sftp_extension?: string }): Promise< { messages?: any[] }> {
    if(!this._sftp_pull_and_submit) { 
      this._sftp_pull_and_submit = this.injector.get(app_sftp_pull_and_submitService);
    }
    return this._sftp_pull_and_submit.run($inParams);
  }
   
   

   
 
  private _sftp_push: app_sftp_pushService;
  public async sftp_push($inParams: { connection: string, target_path: string, file_content: string, transaction_type?: string }): Promise< { messages?: any[], success?: boolean }> {
    if(!this._sftp_push) { 
      this._sftp_push = this.injector.get(app_sftp_pushService);
    }
    return this._sftp_push.run($inParams);
  }
   
   

   
}
